import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/why-patients-travel-to-florida-for-saint-tms",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "travel-for-saint-tms" },
      replace: true,
    });
  },
});
